var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes },
    [
      _vm.header || _vm.$slots.header
        ? _c(
            "div",
            { staticClass: "ivu-list-header" },
            [
              _vm._t("header", function() {
                return [_vm._v(_vm._s(_vm.header))]
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "ivu-list-container" }, [
        _c("ul", { staticClass: "ivu-list-items" }, [_vm._t("default")], 2)
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("Spin", { attrs: { fix: "", size: "large" } }, [_vm._t("spin")], 2)
        : _vm._e(),
      _vm._v(" "),
      _vm.footer || _vm.$slots.footer
        ? _c(
            "div",
            { staticClass: "ivu-list-footer" },
            [
              _vm._t("footer", function() {
                return [_vm._v(_vm._s(_vm.footer))]
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2666c3c5", { render: render, staticRenderFns: staticRenderFns })
  }
}